export const ALLERGENS = [
  {
    label: '小麦',
    value: 'wheat',
  },
  {
    label: '卵',
    value: 'egg',
  },
  {
    label: '乳',
    value: 'milk',
  },
  {
    label: 'そば',
    value: 'soba',
  },
  {
    label: '落花生',
    value: 'peanuts',
  },
  {
    label: 'くるみ',
    value: 'walnut',
  },
  {
    label: 'えび',
    value: 'shrimp',
  },
  {
    label: 'かに',
    value: 'crub',
  },
  {
    label: 'カシューナッツ',
    value: 'cashew_nuts',
  },
]
